import { render, staticRenderFns } from "./AdminEventCodeDetail.vue?vue&type=template&id=c0ecfda4&scoped=true"
import script from "./AdminEventCodeDetail.vue?vue&type=script&lang=js"
export * from "./AdminEventCodeDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminEventCodeDetail.vue?vue&type=style&index=0&id=c0ecfda4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ecfda4",
  null
  
)

export default component.exports